export default __webpack_public_path__ + "static/assets/93629e2fcf65ceb369724eca05b28547.png";